export const visit = (vm, at) => {
at({ "en": { "phoneSupport": { "needHelp": "Need help choosing a plan?", "stillHaveQuestions": "Still have questions about how HubSpot's software can help your business?" } } });
};